import request from '@/utils/request'


export function getList() {
  return request({
    url: '/config/index',
    method: 'get',
  })
}



// WEBPACK FOOTER //
// ./src/api/settings.js